import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

import BsInputPassword from "../../../common/BsInputPassword";

interface ILoginForm {
  user_email: string;
  user_password: string;
}

export default function SuperUserManagerLoginForm({
  setShowLogin,
  onSubmitLogin,
  loading
}: {
  setShowLogin: (value: boolean) => void;
  onSubmitLogin: (values: ILoginForm) => void;
  loading?: boolean;
}) {
  const { t } = useTranslation();
  const schemaLogin = Yup.object({
    user_email: Yup.string()
      .email()
      .required(t("SuperUserManager/emailRequired")),
    user_password: Yup.string().required(t("SuperUserManager/passwordRequired"))
  });

  const {
    register,
    reset,
    setValue,
    handleSubmit,
    getValues,
    formState: { errors }
  } = useForm<ILoginForm>({
    defaultValues: {
      user_password: "",
      user_email: ""
    },
    resetOptions: {
      keepDefaultValues: true
    },
    resolver: yupResolver(schemaLogin) as any,
    mode: "onSubmit"
  });
  const ButtonSubmit = (data: ILoginForm) => {
    onSubmitLogin(data);
  };

  return (
    <div className="tw-w-full">
      <form
        onSubmit={handleSubmit(ButtonSubmit)}
        className="tw-self-stretch tw-px-4 tw-py-3 tw-bg-white tw-rounded-md tw-shadow tw-border tw-border-gray-300 login-form"
      >
        <Form.Group className="mb-3">
          <Form.Label htmlFor="user_email" className="login-label">
            {t("SuperUserManager/email")}
          </Form.Label>
          <Form.Control
            className="login-input"
            id="user_email"
            type="email"
            {...register("user_email")}
          />
          <Form.Control.Feedback
            type="invalid"
            className="d-block font-poppins"
          >
            {errors.user_email?.message as string}
          </Form.Control.Feedback>
        </Form.Group>

        <BsInputPassword
          label={t("SuperUserManager/password")}
          isInvalid={!!errors.user_password}
          errorMessage={errors.user_password?.message as string}
          className={"mb-3"}
          rhfControls={register("user_password")}
        />

        <div className="tw-flex tw-flex-inline tw-justify-start tw-mt-4 tw-gap-3">
          <Button
            type="submit"
            className="tw-h-11 tw-px-5 tw-py-3 tw-bg-primary tw-rounded-lg tw-justify-center tw-items-center tw-inline-flex"
            disabled={loading}
          >
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              t("SuperUserManager/login")
            )}
          </Button>

          <Button
            type="reset"
            onClick={() => setShowLogin(false)}
            className="tw-h-11 tw-px-5 tw-py-3 tw-bg-gray-400 tw-rounded-lg tw-justify-center tw-items-center tw-inline-flex"
          >
            {t("SuperUserManager/cancel")}
          </Button>
        </div>
      </form>
    </div>
  );
}
